import {swipers} from '../js/components/swipers';

swipers();

import {mask} from '../js/components/mask';

mask();

import {validation} from '../js/components/validation';

validation();

import {customSelect} from '../js/components/customSelect';

customSelect();
import {tabs} from '../js/components/tabs';

tabs();

import initCaptchaOnForm from './components/captcha';

initCaptchaOnForm(".js-contacts-form-with-captcha", ".js-contacts-form-submit-btn", "contacts-form-captcha-container");
initCaptchaOnForm(".js-modal-contact-form", ".js-modal-contact-form-submit-btn", "modal-contacts-form-captcha-container");

initCaptchaOnForm(".js-modal-vip-form", ".js-modal-vip-form-btn", "modal-vip-form-captcha-container");

import {dropdown} from '../js/components/dropdown';

dropdown()
